const baseUrl = process.env.VUE_APP_API_;

async function fetchData(url, config) {
    try {
        return await fetch(`${baseUrl}${url}`, config);
    } catch (error) {
        console.error('Fetch error:', error);
        return {
            ok: false,
            status: 500,
            json: async () => ({ error: 'Network error or server not available' })
        };
    }
}

function createFetchConfig(method, body = null) {
    const headers = { 'Content-Type': 'application/json' };
    const config = { method, headers };

    if (body) {
        config.body = JSON.stringify(body);
    }

    return config;
}

async function GET(url) {
    return fetchData(url, createFetchConfig('GET'));
}

async function POST(url, body) {
    return fetchData(url, createFetchConfig('POST', body));
}

async function PUT(url, body) {
    return fetchData(url, createFetchConfig('PUT', body));
}

export default {
    GET,
    POST,
    PUT
};